import { useRef, useState } from "react";

/** A yes/no question answered through a dialog, awaited like a promise. */
export function useConfirm() {
  const [open, setOpen] = useState(false);
  const answer = useRef<(yes: boolean) => void>(() => {});
  return {
    open,
    ask: () =>
      new Promise<boolean>((resolve) => {
        answer.current = resolve;
        setOpen(true);
      }),
    reply(yes: boolean) {
      setOpen(false);
      answer.current(yes);
    },
  };
}
